// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previewShareModalContainer_xTuOw {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	padding: 20px;
	border-radius: 5px;
	gap: 10px;
	background-color: var(--f5-background);
}
.title_hO4ov {
	font-size: 22px;
	font-weight: 600;
	color: var(--_3c3a3a-color);
}
.addGuestsContainer_recTM {
	align-items: center;
	display: flex;
	justify-content: flex-start;
	flex-direction: row;
	gap: 10px;
	height: 35px;
	position: relative;
}
.addGuestsInputWrapper_OKRSp {
	display: flex;
	align-items: center;
	width: 400px;
	min-width: 400px;
	justify-content: flex-start;
	min-height: 35px;
	height: 35px;
	max-height: 35px;
	height: 100%;
	position: relative;
}

.addGuestsInput_o2uFe {
	border: none;
	outline: none;
	padding-left: 10px;
	width: 100%;
	border-radius: 4px;
	background-color: var(--f5-background);
	height: 100%;
}
.initial_DY_e7 {
	font-size: 18px;
	color: white;
	background-color: #4285f4;
	width: 30px;
	height: 30px;
	min-width: 30px;
	min-height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
}

.invitedUsersContainer_d4wp1 {
	width: 270px;
	min-height: 63px;
	max-height: 100px;
	overflow-y: auto;
	margin-left: 30px;
	display: flex;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	gap: 4px;
}

.invitedUserCard_mwCkd {
	display: flex;
	padding: 0px 8px;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	height: 35px;
	gap: 10px;
	font-size: 15px;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	border-radius: 4px;
	position: relative;
}

.invitedUserCard_mwCkd:hover {
	background: var(--_16c0982e-background);
}

.closeButtonContainer_hYTjz {
	margin-left: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	visibility: hidden;
}

.invitedUserCard_mwCkd:hover .closeButtonContainer_hYTjz {
	visibility: visible;
}

.closeButton_Qnjq3 {
	color: var(--color-text);
	font-size: 18px;
	cursor: pointer;
	padding: 2px;
	border-radius: 50%;
}

.closeButton_Qnjq3:hover {
	background-color: var(--_16c098-color);
}

.tooltip_jPmsw {
	visibility: hidden;
	background-color: #666;
	color: #fff;
	text-align: center;
	padding: 4px 8px;
	border-radius: 4px;
	position: absolute;
	top: -12px;
	left: -65px;
	margin-top: 8px;
	white-space: nowrap;
	z-index: 1;
	font-size: 12px;
}

.closeButtonContainer_hYTjz:hover .tooltip_jPmsw {
	visibility: visible;
}

.inputContainer_scQy7 {
	display: flex;
	height: 35px;
	border-radius: 4px 4px 0px 0px;
	width: 400px;
	position: relative;
	align-items: center;
	justify-content: center;
	background: var(--f5-background);
}

.input_wmJpG {
	width: 100%;
	padding: 4px 6px;
	border: none;
	border-bottom: 2px solid #d1d1d1;
	outline: none;
	height: 100%;
	font-size: 14px;
	background: transparent;
	font-weight: 500;
	color: #6e6e6e;
}

.input_wmJpG::placeholder {
	color: #6e6e6e;
}

.underline_tJLoe {
	position: absolute;
	bottom: 0;
	width: 0;
	width: 0%;
	height: 2px;
	background: var(--_16c098-color);
	transition: width 0.3s ease;
}

.focused_vOHO_ {
	border-bottom-color: transparent;
}

.active_J7E3R {
	width: 100%;
}

.inviteButton_KYSrN {
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px 20px;
	color: var(--white-color);
	background: var(--_16c09821-background);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	transition: background 0.3s ease-in-out;
	&:hover {
		background: var(--e6fff9-background);
	}
}

.disabledInviteButton_NE__6 {
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px 20px;
	background: var(--_16c0982e-background);
	color: var(--white-color);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	justify-self: flex-end;
}
.fullWR_I_Hfn {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-direction: row;
	width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/PreviewShareModal.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,uBAAuB;CACvB,aAAa;CACb,kBAAkB;CAClB,SAAS;CACT,sCAAsC;AACvC;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,2BAA2B;AAC5B;AACA;CACC,mBAAmB;CACnB,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;CACnB,SAAS;CACT,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;CAChB,2BAA2B;CAC3B,gBAAgB;CAChB,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,sCAAsC;CACtC,YAAY;AACb;AACA;CACC,eAAe;CACf,YAAY;CACZ,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,mBAAmB;CACnB,2BAA2B;CAC3B,WAAW;CACX,YAAY;CACZ,SAAS;CACT,eAAe;CACf,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,eAAe;CACf,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,8BAA8B;CAC9B,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,gCAAgC;CAChC,aAAa;CACb,YAAY;CACZ,eAAe;CACf,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,SAAS;CACT,WAAW;CACX,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,yBAAyB;CACzB,uCAAuC;CACvC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,uCAAuC;CACvC;EACC,oCAAoC;CACrC;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,uCAAuC;CACvC,yBAAyB;CACzB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;AACZ","sourcesContent":[".previewShareModalContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tpadding: 20px;\n\tborder-radius: 5px;\n\tgap: 10px;\n\tbackground-color: var(--f5-background);\n}\n.title {\n\tfont-size: 22px;\n\tfont-weight: 600;\n\tcolor: var(--_3c3a3a-color);\n}\n.addGuestsContainer {\n\talign-items: center;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\tgap: 10px;\n\theight: 35px;\n\tposition: relative;\n}\n.addGuestsInputWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 400px;\n\tmin-width: 400px;\n\tjustify-content: flex-start;\n\tmin-height: 35px;\n\theight: 35px;\n\tmax-height: 35px;\n\theight: 100%;\n\tposition: relative;\n}\n\n.addGuestsInput {\n\tborder: none;\n\toutline: none;\n\tpadding-left: 10px;\n\twidth: 100%;\n\tborder-radius: 4px;\n\tbackground-color: var(--f5-background);\n\theight: 100%;\n}\n.initial {\n\tfont-size: 18px;\n\tcolor: white;\n\tbackground-color: #4285f4;\n\twidth: 30px;\n\theight: 30px;\n\tmin-width: 30px;\n\tmin-height: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n}\n\n.invitedUsersContainer {\n\twidth: 270px;\n\tmin-height: 63px;\n\tmax-height: 100px;\n\toverflow-y: auto;\n\tmargin-left: 30px;\n\tdisplay: flex;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tflex-direction: column;\n\tgap: 4px;\n}\n\n.invitedUserCard {\n\tdisplay: flex;\n\tpadding: 0px 8px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\twidth: 100%;\n\theight: 35px;\n\tgap: 10px;\n\tfont-size: 15px;\n\tcursor: pointer;\n\tuser-select: none;\n\tborder-radius: 4px;\n\tposition: relative;\n}\n\n.invitedUserCard:hover {\n\tbackground: var(--_16c0982e-background);\n}\n\n.closeButtonContainer {\n\tmargin-left: auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n\tvisibility: hidden;\n}\n\n.invitedUserCard:hover .closeButtonContainer {\n\tvisibility: visible;\n}\n\n.closeButton {\n\tcolor: var(--color-text);\n\tfont-size: 18px;\n\tcursor: pointer;\n\tpadding: 2px;\n\tborder-radius: 50%;\n}\n\n.closeButton:hover {\n\tbackground-color: var(--_16c098-color);\n}\n\n.tooltip {\n\tvisibility: hidden;\n\tbackground-color: #666;\n\tcolor: #fff;\n\ttext-align: center;\n\tpadding: 4px 8px;\n\tborder-radius: 4px;\n\tposition: absolute;\n\ttop: -12px;\n\tleft: -65px;\n\tmargin-top: 8px;\n\twhite-space: nowrap;\n\tz-index: 1;\n\tfont-size: 12px;\n}\n\n.closeButtonContainer:hover .tooltip {\n\tvisibility: visible;\n}\n\n.inputContainer {\n\tdisplay: flex;\n\theight: 35px;\n\tborder-radius: 4px 4px 0px 0px;\n\twidth: 400px;\n\tposition: relative;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: var(--f5-background);\n}\n\n.input {\n\twidth: 100%;\n\tpadding: 4px 6px;\n\tborder: none;\n\tborder-bottom: 2px solid #d1d1d1;\n\toutline: none;\n\theight: 100%;\n\tfont-size: 14px;\n\tbackground: transparent;\n\tfont-weight: 500;\n\tcolor: #6e6e6e;\n}\n\n.input::placeholder {\n\tcolor: #6e6e6e;\n}\n\n.underline {\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 0;\n\twidth: 0%;\n\theight: 2px;\n\tbackground: var(--_16c098-color);\n\ttransition: width 0.3s ease;\n}\n\n.focused {\n\tborder-bottom-color: transparent;\n}\n\n.active {\n\twidth: 100%;\n}\n\n.inviteButton {\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 10px 20px;\n\tcolor: var(--white-color);\n\tbackground: var(--_16c09821-background);\n\tcursor: pointer;\n\tuser-select: none;\n\ttransition: background 0.3s ease-in-out;\n\t&:hover {\n\t\tbackground: var(--e6fff9-background);\n\t}\n}\n\n.disabledInviteButton {\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 10px 20px;\n\tbackground: var(--_16c0982e-background);\n\tcolor: var(--white-color);\n\tcursor: pointer;\n\tuser-select: none;\n\tjustify-self: flex-end;\n}\n.fullWR {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tflex-direction: row;\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewShareModalContainer": `previewShareModalContainer_xTuOw`,
	"title": `title_hO4ov`,
	"addGuestsContainer": `addGuestsContainer_recTM`,
	"addGuestsInputWrapper": `addGuestsInputWrapper_OKRSp`,
	"addGuestsInput": `addGuestsInput_o2uFe`,
	"initial": `initial_DY_e7`,
	"invitedUsersContainer": `invitedUsersContainer_d4wp1`,
	"invitedUserCard": `invitedUserCard_mwCkd`,
	"closeButtonContainer": `closeButtonContainer_hYTjz`,
	"closeButton": `closeButton_Qnjq3`,
	"tooltip": `tooltip_jPmsw`,
	"inputContainer": `inputContainer_scQy7`,
	"input": `input_wmJpG`,
	"underline": `underline_tJLoe`,
	"focused": `focused_vOHO_`,
	"active": `active_J7E3R`,
	"inviteButton": `inviteButton_KYSrN`,
	"disabledInviteButton": `disabledInviteButton_NE__6`,
	"fullWR": `fullWR_I_Hfn`
};
export default ___CSS_LOADER_EXPORT___;
